/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from "react"
import ProductionStepExecutionsFilters from "../ProductionStepExecutions/ProductionStepExecutionsFilters"
import { COLORS } from "../../utils"
import { Box } from "@mui/material"
import NoPSEs from "../ProductionStepExecutions/NoPSEs"
import PackagingExecutionCard from "./PackagingExecutionCard"
import { showPackagingExecution } from "../../actions/PackagingExecution/packagingExecution"
import { useDispatch } from "react-redux"
import { EXECUTIONS_SCROLL_SX } from "../../utils/productionStepExecution"

const FILTER_DEFAULTS = {
  searchText: "",
  status: "TODO",
}

const groupPackagingByStatus = (PSETiles) => PSETiles.reduce((acc, tile) => {
  if (!acc[tile.status]) {
    acc[tile.status] = []
  }
  acc[tile.status].push(tile)
  return acc
}, {})

const PackagingExecutionTableNew = ({
  PackagingTiles,
  onStatusChange,
  selectedMenu,
  tabs,
  selectedTab,
  onTabChange,
  site,
  date,
}) => {
  const dispatch = useDispatch()
  const [filters, setFilters] = useState(FILTER_DEFAULTS)
  const [filteredStatusCount, setFilteredStatusCount] = useState(groupPackagingByStatus(PackagingTiles))
  const [statusCounts, setStatusCounts] = useState({})

  const tilesForCurrentMenu = useMemo(() => {
    if (!tabs || tabs.length === 0) return PackagingTiles
    return PackagingTiles.filter(tile => tabs.some(tab => tab.filter(tile)))
  }, [PackagingTiles, tabs])

  const filteredTiles = useMemo(() => {
    let tiles = PackagingTiles
    if (filters.status && tabs?.length > 0) {
      const activeTab = tabs.find(tab => tab.value === filters.status)
      tiles = activeTab ? tiles.filter(activeTab.filter) : tiles.filter(tile => tile.status === filters.status)
    }
    if (filters.searchText) {
      const searchTextLower = filters.searchText.toLowerCase()
      tiles = tiles.filter(tile => `${tile.recipeName}${tile.uniqueCode || ""}`.toLowerCase().includes(searchTextLower))
    }
    if (filters.packagingLine?.length > 0) {
      tiles = tiles.filter(tile => filters.packagingLine.includes(tile.packagingLineName))
    }
    if (filters.packagingExecutionSpecificity?.length > 0) {
      tiles = tiles.filter(tile => filters.packagingExecutionSpecificity.some(specificity => tile[specificity]))
    }
    const newStatusCount = groupPackagingByStatus(PackagingTiles)
    setFilteredStatusCount(newStatusCount)
    if (tabs?.length > 0) {
      setStatusCounts(tabs.reduce((acc, tab) => {
        acc[tab.value] = PackagingTiles.filter(tab.filter).length
        return acc
      }, {}))
    } else {
      setStatusCounts(Object.keys(newStatusCount).reduce((acc, status) => {
        acc[status] = newStatusCount[status].length
        return acc
      }, {}))
    }
    return tiles
  }, [filters, PackagingTiles, tabs])

  const handleFilterChange = (newFilters) => {
    setFilters({ ...filters, ...newFilters })
    if (newFilters.status !== undefined && onTabChange) {
      onTabChange(newFilters.status)
    }
  }

  const onClickPe = (pe) => {
    dispatch(showPackagingExecution(site.objectId, date, pe.objectId))
  }

  useEffect(() => {
    const defaultTab = tabs?.length > 0 ? tabs[0].value : FILTER_DEFAULTS.status
    // Restore previously selected tab if it still belongs to the current menu, otherwise use default
    const restoredTab = selectedTab && tabs?.some(t => t.value === selectedTab) ? selectedTab : defaultTab
    setFilters({ ...FILTER_DEFAULTS, status: restoredTab })
  }, [tabs])

  return (
    <Box sx={styles.rightSide}>
      <ProductionStepExecutionsFilters
        PSETiles={tilesForCurrentMenu}
        filters={filters}
        onFilterChange={handleFilterChange}
        selectedStatus={filters.status}
        onStatusChange={onStatusChange}
        statusCounts={statusCounts}
        selectedMenu={selectedMenu}
        tabs={tabs}
        isSidebarExpanded
        mode="PACKAGING_EXECUTIONS"
      />

      <Box sx={styles.tilesContainer}>
        {filteredTiles.length === 0 ? (
          <NoPSEs
            selectedMenu={selectedMenu}
            statusNotificationCounts={filteredStatusCount}
            selectedStatus={filters.status}
            mode="PACKAGING_EXECUTIONS"
          />
        ) : (
          <Box sx={styles.tilesGrid}>
            {filteredTiles.map((tile) => (
              <PackagingExecutionCard
                item={tile}
                key={tile.objectId}
                onClick={() => onClickPe(tile)}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  )
}

const styles = {
  rightSide: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
    flex: 1,
    gap: "32px",
    ...EXECUTIONS_SCROLL_SX,
  },
  tilesContainer: {
    flex: 1,
  },
  tilesGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  emptyState: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
  emptyData: {
    fontSize: "20px",
    color: COLORS.BLACK800,
    textAlign: "center",
    lineHeight: 1.4,
    fontWeight: 500,
  },
}

export default PackagingExecutionTableNew